/**
 * FERAL Fit Charts — Shared Data Registry
 * ════════════════════════════════════════════════════════
 * This file is the SINGLE SOURCE OF TRUTH for all size chart configs.
 * Both the product-page fit guide (feral-size-guide.liquid) and the
 * standalone Fit Guide page (feral-fit-guide.liquid) load from here.
 *
 * TO ADD A NEW PRODUCT CATEGORY:
 *   1. Add a new entry below following the existing pattern
 *   2. Run: node deploy-fit-charts.js
 *   3. Both pages automatically pick up the new chart
 *
 * Chart IDs must match the tags used on products (fsg-chart:<id>)
 * and the type-routing in feral-size-guide.liquid.
 */

window.FERAL_FIT_CHARTS = window.FERAL_FIT_CHARTS || {};


// Every chart uses the same schema:
//   columns: table headers (label + key into each size row)
//   sizes:   row data — `chest` is always FULL garment chest circumference (cm) for Fit Finder math
//   ease:    target chest ease in cm for each fit preference

window.FERAL_FIT_CHARTS['hoodie-standard'] = {
  productType: 'hoodie',
  gender: 'unisex',
  chartTitle: 'THE FERAL HOODIE',
  fitCopy: 'Unisex, boxy fit with a subtle cropped length. Relaxed and roomy without running long. True to size is the move. Size up only if you want an extra oversized drape or have a longer torso.',
  diagramUrl: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJzaXplY2hhcnRzcmVsZW50bGVzcyIsImtleSI6ImFhYjkzMi5teXNob3BpZnkuY29tLzE3NjM5ODg1NjQ4NTktZmVyYWxibGFja2hvb2RpZS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjY2MCwiZml0IjoiY29udGFpbiJ9fX0=',
  columns: [
    { key: 'chestHalf', label: 'Chest',  measureHint: 'Lay the garment flat, measure armpit to armpit.' },
    { key: 'length',    label: 'Length', measureHint: 'From the highest shoulder seam straight down to the hem.' },
    { key: 'sleeve',    label: 'Sleeve', measureHint: 'From the shoulder seam along the top of the sleeve to the cuff.' }
  ],
  sizes: [
    { size: 'XS',  chest: 122, chestHalf: 61,   length: 63, sleeve: 58.5 },
    { size: 'S',   chest: 127, chestHalf: 63.5, length: 65, sleeve: 59.5 },
    { size: 'M',   chest: 132, chestHalf: 66,   length: 67, sleeve: 60.5 },
    { size: 'L',   chest: 137, chestHalf: 68.5, length: 69, sleeve: 61.5 },
    { size: 'XL',  chest: 142, chestHalf: 71,   length: 71, sleeve: 62.5 },
    { size: 'XXL', chest: 147, chestHalf: 73.5, length: 73, sleeve: 63.5 }
  ],
  // HEIGHT-BAND v2: each band's `minCm` is the lower bound for that baseline size at "true to size".
  // BMI nudge: <19 = -1, >27 = +1, >31 = +2. Fit pref shifts: closer = -1, oversized via oversizedShift.
  heightBands: [
    [0,   'XS'],
    [158, 'S'],
    [170, 'M'],
    [184, 'L'],
    [192, 'XL'],
    [200, 'XXL']
  ],
  oversizedShift: { male: 1, female: 1, neutral: 1 },
  closerShift:    { male: -1, female: -1, neutral: -1 },
  wizardCopy: {
    fitStepSub: 'The FERAL hoodie is drafted as a boxy, drop-shoulder silhouette. Pick the drape you\'re going for.',
    fitChoices: {
      closer:    { desc: 'Less oversized, cleaner line.' },
      'true':    { desc: 'The boxy drape shown on the model.' },
      oversized: { desc: 'Drapey, dropped-shoulder oversized.' }
    }
  }
};

window.FERAL_FIT_CHARTS['tee-standard'] = {
  productType: 'tee',
  gender: 'unisex',
  chartTitle: 'FERAL T-SHIRT',
  fitCopy: 'Our take on the oversized tee — boxy, structured, premium 240 GSM. Designed to sit deliberately on any frame. True to size is the move.',
  diagramUrl: null, // no diagram available — the guide renders without the figure
  columns: [
    { key: 'chestHalf', label: 'Chest',   measureHint: 'Lay the tee flat, measure armpit to armpit.' },
    { key: 'length',    label: 'Length',  measureHint: 'From the highest shoulder seam straight down to the hem.' },
    { key: 'sleeve',    label: 'Sleeve',  measureHint: 'From the shoulder seam along the top of the sleeve to the cuff.' },
    { key: 'shoulder',  label: 'Shoulder', measureHint: 'Straight across the top of the garment, seam to seam.' }
  ],
  sizes: [
    { size: 'XS',  chest: 110, chestHalf: 55,   length: 64, sleeve: 19.75, shoulder: 20   },
    { size: 'S',   chest: 114, chestHalf: 57,   length: 66, sleeve: 20.55, shoulder: 20.3 },
    { size: 'M',   chest: 121, chestHalf: 60.5, length: 68, sleeve: 21.25, shoulder: 20.6 },
    { size: 'L',   chest: 126, chestHalf: 63,   length: 70, sleeve: 22,    shoulder: 21   },
    { size: 'XL',  chest: 131, chestHalf: 65.5, length: 72, sleeve: 22.7,  shoulder: 21.4 },
    { size: 'XXL', chest: 138, chestHalf: 69,   length: 75, sleeve: 23.5,  shoulder: 22.1 }
  ],
  // HEIGHT-BAND v2. Boxy 240gsm tee.
  heightBands: [
    [0,   'XS'],
    [158, 'S'],
    [168, 'M'],
    [184, 'L'],
    [192, 'XL'],
    [200, 'XXL']
  ],
  oversizedShift: { male: 1, female: 1, neutral: 1 },
  closerShift:    { male: -1, female: -1, neutral: -1 },
  wizardCopy: {
    fitStepSub: 'Our tee is built boxy and structured at 240 GSM — it sits deliberately on the body. Pick how you want it to drape.',
    fitChoices: {
      closer:    { desc: 'Less oversized — sits closer to the body.' },
      'true':    { desc: 'The boxy drape shown on the model.' },
      oversized: { desc: 'A bigger, boyfriend-tee drape.' }
    }
  }
};

window.FERAL_FIT_CHARTS['zip-up-standard'] = {
  productType: 'zip-up',
  gender: 'unisex',
  chartTitle: 'FERAL ZIP-UP HOODIE',
  fitCopy: 'Our zip-up sits closer to the body than the pullover — built as an outerwear layer with structure. True to size gives a clean line; size up for a more relaxed fit over thicker pieces.',
  diagramUrl: 'https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJzaXplY2hhcnRzcmVsZW50bGVzcyIsImtleSI6ImFhYjkzMi5teXNob3BpZnkuY29tLzE3NjM5ODg1NjQ4NTktZmVyYWxibGFja2hvb2RpZS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjY2MCwiZml0IjoiY29udGFpbiJ9fX0=',
  columns: [
    { key: 'chestHalf', label: 'Chest',  measureHint: 'Lay the garment flat (zip closed), measure armpit to armpit.' },
    { key: 'length',    label: 'Length', measureHint: 'From the highest shoulder seam straight down to the hem.' },
    { key: 'sleeve',    label: 'Sleeve', measureHint: 'From the shoulder seam along the top of the sleeve to the cuff.' }
  ],
  // Same physical garment dimensions as the pullover — the cut only differs in ease recommendations.
  sizes: [
    { size: 'XS',  chest: 122, chestHalf: 61,   length: 63, sleeve: 58.5 },
    { size: 'S',   chest: 127, chestHalf: 63.5, length: 65, sleeve: 59.5 },
    { size: 'M',   chest: 132, chestHalf: 66,   length: 67, sleeve: 60.5 },
    { size: 'L',   chest: 137, chestHalf: 68.5, length: 69, sleeve: 61.5 },
    { size: 'XL',  chest: 142, chestHalf: 71,   length: 71, sleeve: 62.5 },
    { size: 'XXL', chest: 147, chestHalf: 73.5, length: 73, sleeve: 63.5 }
  ],
  // HEIGHT-BAND v2. Zip-up runs closer than pullover — bands push baseline down vs hoodie.
  heightBands: [
    [0,   'XS'],
    [167, 'S'],
    [180, 'M'],
    [190, 'L'],
    [198, 'XL']
  ],
  oversizedShift: { male: 1, female: 1, neutral: 1 },
  closerShift:    { male: -1, female: -1, neutral: -1 },
  wizardCopy: {
    fitStepSub: 'The zip-up sits closer to the body than the pullover — built as outerwear with structure. Pick the fit you\'re going for.',
    fitChoices: {
      closer:    { desc: 'A clean, fitted line over a tee.' },
      'true':    { desc: 'Structured fit shown on the model.' },
      oversized: { desc: 'Roomier — fits over thicker layers.' }
    }
  }
};

// ——————————————————————————————————————————————————————————————————
// BABY TEE — fundamentally different from the boxy tee.
//   - Form-fitting cropped crew. 93% cotton / 7% spandex (stretch). 220 GSM.
//   - Sized by UK dress size (NOT chest circumference like other charts).
//   - Brand explicitly: "runs small — size up for a comfier fit."
//   - Last 30d sales (126 units): XS 16% / S 20% / M 30% / L 27% / XL 4% / XXL 3%.
//
// Recommendation logic uses CHEST bands (not height bands), since dress size is
// chest-driven on close-fitting wear. Body-chest formula already incorporates BMI,
// so no extra BMI nudge is applied (avoids double-counting).
// ——————————————————————————————————————————————————————————————————
window.FERAL_FIT_CHARTS['baby-tee-standard'] = {
  productType: 'baby-tee',
  gender: 'female',
  chartTitle: 'FERAL BABY TEE',
  fitCopy: 'Cropped fit in stretchy cotton-spandex (93/7, 220 GSM). True to size gives the snug baby-tee silhouette shown in the photos. Size up if you want it less cropped or more relaxed — the brand runs small.',
  diagramUrl: null,
  // Columns: UK/EU/USA are ranges (non-numeric, unit: null = skip cm/in toggle).
  // length + sleeve are real cm measurements.
  columns: [
    { key: 'uk',     label: 'UK',     unit: null,  measureHint: 'Match this to your usual UK dress size (4 = small frame, 16 = larger frame).' },
    { key: 'eu',     label: 'EU',     unit: null,  measureHint: 'European dress sizing equivalent.' },
    { key: 'usa',    label: 'US',     unit: null,  measureHint: 'US dress sizing equivalent.' },
    { key: 'length', label: 'Length', unit: 'cm',  measureHint: 'From the highest point of the shoulder seam straight down to the cropped hem.' },
    { key: 'sleeve', label: 'Sleeve', unit: 'cm',  measureHint: 'From the shoulder seam to the cap-sleeve cuff.' }
  ],
  sizes: [
    { size: 'XS',  uk: '4-6',   eu: '32-34', usa: '0-2',   length: 47, sleeve: 11 },
    { size: 'S',   uk: '6-8',   eu: '34-36', usa: '2-4',   length: 48, sleeve: 12 },
    { size: 'M',   uk: '8-10',  eu: '36-38', usa: '4-6',   length: 49, sleeve: 13 },
    { size: 'L',   uk: '10-12', eu: '38-40', usa: '6-8',   length: 50, sleeve: 14 },
    { size: 'XL',  uk: '12-14', eu: '40-42', usa: '8-10',  length: 51, sleeve: 15 },
    { size: 'XXL', uk: '14-16', eu: '42-44', usa: '10-12', length: 52, sleeve: 16 }
  ],
  // Chest-band lookup. Estimated body chest (cm) → baby tee size.
  // Tuned so: Andie 165/55 (chest ~84.5) → S; Jasmin 160/64 (89.3) → M; plus-size (96+) → L.
  // Bands sit slightly below pure UK conversion to honour the "runs small" warning.
  chestBands: [
    [0,   'XS'],
    [83,  'S'],
    [88,  'M'],
    [93,  'L'],
    [98,  'XL'],
    [103, 'XXL']
  ],
  // closer = ultra-tight crop / oversized = comfier relaxed fit.
  oversizedShift: { male: 1, female: 1, neutral: 1 },
  closerShift:    { male: -1, female: -1, neutral: -1 },
  wizardCopy: {
    fitStepSub: 'The baby tee is cropped and form-fitting in stretch cotton-spandex. Pick how snug you want it to sit — it runs small, so size up if you want it less cropped.',
    fitChoices: {
      closer:    { label: 'Snug & cropped',    desc: 'Tighter through the body, sits higher on the waist.' },
      'true':    { label: 'True to size',      desc: 'The fit shown on the model.' },
      oversized: { label: 'Looser fit',        desc: 'Less cropped — sits a touch lower, less belly showing.' }
    }
  },
  // Baby-tee uses the size-input step (UK / EU / US / Bust) instead of height + weight.
  inputMode: 'size',
  // Direct dress-size → baby-tee-size maps. All maps verified against the chart's UK/EU/US ranges.
  // UK 4-6=XS, 6-8=S, 8-10=M, 10-12=L, 12-14=XL, 14-16=XXL → at boundaries we size UP one to honour
  // the "runs small" warning (e.g. UK 6 → S not XS).
  ukSizeMap: { '4': 'XS', '6': 'S', '8': 'M', '10': 'L', '12': 'XL', '14': 'XXL', '16': 'XXL' },
  // EU 32-34=XS, 34-36=S, 36-38=M, 38-40=L, 40-42=XL, 42-44=XXL → same boundary rule
  euSizeMap: { '32': 'XS', '34': 'S', '36': 'M', '38': 'L', '40': 'XL', '42': 'XXL', '44': 'XXL' },
  // US 0-2=XS, 2-4=S, 4-6=M, 6-8=L, 8-10=XL, 10-12=XXL → same boundary rule
  usSizeMap: { '0': 'XS', '2': 'S', '4': 'M', '6': 'L', '8': 'XL', '10': 'XXL', '12': 'XXL' },
  // Bust (cm) bands — same as chestBands but explicitly for direct bust input.
  bustBands: [
    [0,   'XS'],
    [83,  'S'],
    [88,  'M'],
    [93,  'L'],
    [98,  'XL'],
    [103, 'XXL']
  ]
};

// ——————————————————————————————————————————————————————————————————
// BIKINI TOP — triangle with adjustable ties. 82% nylon / 18% spandex.
// Sizing driven by CUP SIZE (adjustable ties handle the band).
// Coverage step replaces fit-preference step.
// ——————————————————————————————————————————————————————————————————
window.FERAL_FIT_CHARTS['bikini-top-standard'] = {
  productType: 'bikini-top',
  gender: 'female',
  chartTitle: 'FERAL BIKINI TOP',
  fitCopy: 'Triangle bikini with adjustable ties at the neck and underbust. Removable pads included. The main difference between sizes is the cup coverage — size up for more, or size down for a more minimal fit.',
  diagramUrl: null,
  inputMode: 'size',
  columns: [
    { key: 'bra',       label: 'Bra',       unit: null, measureHint: 'Your usual bra cup letter (A through E).' },
    { key: 'uk',        label: 'UK',         unit: null, measureHint: 'Match to your UK dress size.' },
    { key: 'eu',        label: 'EU',         unit: null, measureHint: 'European dress size equivalent.' },
    { key: 'cupHeight', label: 'Cup Height', unit: 'cm', measureHint: 'Triangle height from base to point — taller = more coverage.' },
    { key: 'bust',      label: 'Bust',       unit: null, measureHint: 'Bust circumference in cm (fullest point, tape level).' },
    { key: 'underbust',  label: 'Underbust',  unit: null, measureHint: 'Underbust circumference in cm (snug, just below bust).' }
  ],
  sizes: [
    { size: 'XS',  bra: 'A-B',  uk: '6',     eu: '34',    cupHeight: 15, bust: '79-84',   underbust: '64-69' },
    { size: 'S',   bra: 'B-C',  uk: '8-10',  eu: '36-38', cupHeight: 17, bust: '84-89',   underbust: '69-74' },
    { size: 'M',   bra: 'C',    uk: '10-12', eu: '38-40', cupHeight: 18, bust: '89-94',   underbust: '74-79' },
    { size: 'L',   bra: 'D',    uk: '12-14', eu: '40-42', cupHeight: 19, bust: '94-99',   underbust: '79-84' },
    { size: 'XL',  bra: 'DD',   uk: '14-16', eu: '42-44', cupHeight: 20, bust: '99-104',  underbust: '84-89' },
    { size: 'XXL', bra: 'DD-E', uk: '16-18', eu: '44-46', cupHeight: 22, bust: '104-109', underbust: '89-94' }
  ],
  // Direct input maps
  ukSizeMap:  { '6': 'XS', '8': 'S', '10': 'M', '12': 'L', '14': 'XL', '16': 'XXL', '18': 'XXL' },
  euSizeMap:  { '34': 'XS', '36': 'S', '38': 'M', '40': 'L', '42': 'XL', '44': 'XXL', '46': 'XXL' },
  usSizeMap:  { '2': 'XS', '4': 'S', '6': 'M', '8': 'L', '10': 'XL', '12': 'XXL', '14': 'XXL' },
  // Bra cup → size (coverage height)
  braCupMap:  { 'A': 'XS', 'B': 'S', 'C': 'M', 'D': 'L', 'DD': 'XL', 'E': 'XXL' },
  // Band (underbust inches) → size (frame fit). Ties adjust ±1 but can't bridge 2+ sizes.
  braBandMap: { '28': 'XS', '30': 'XS', '32': 'S', '34': 'M', '36': 'L', '38': 'XL', '40': 'XXL' },
  // Bust bands for direct bust-cm input
  bustBands:  [ [0,'XS'], [84,'S'], [89,'M'], [94,'L'], [99,'XL'], [104,'XXL'] ],
  chestBands: [ [0,'XS'], [84,'S'], [89,'M'], [94,'L'], [99,'XL'], [104,'XXL'] ],
  // Coverage replaces closer/true/oversized. "less" = more skin (-1), "more" = fuller coverage (+1).
  coverageStep: true,
  oversizedShift: { male: 1, female: 1, neutral: 1 },
  closerShift:    { male: -1, female: -1, neutral: -1 },
  wizardCopy: {
    fitStepSub: 'Adjustable ties let you fine-tune the band. The cup coverage is what changes between sizes.',
    fitChoices: {
      closer:    { label: 'Minimal coverage', desc: 'Less triangle, more skin.' },
      'true':    { label: 'Photo fit',        desc: 'The coverage shown on the model.' },
      oversized: { label: 'Extra coverage',   desc: 'Fuller cups for more confidence.' }
    }
  }
};

// ——————————————————————————————————————————————————————————————————
// BIKINI BOTTOM — tie-side bottoms. Table-only chart (noFinder). The ties at
// both hips are fully adjustable, so garment measurements aren't meaningful
// for fit — the chart is just a UK / EU size conversion. UK/EU mirror the
// matched bikini-top sizing. (No cm columns → the render auto-hides the
// CM/IN toggle and the "how to measure" section.)
// ——————————————————————————————————————————————————————————————————
window.FERAL_FIT_CHARTS['bikini-bottom-standard'] = {
  productType: 'bikini-bottom',
  gender: 'female',
  chartTitle: 'FERAL BIKINI BOTTOMS',
  fitCopy: 'Tie-side bikini bottoms — fully adjustable strings at both hips let you cinch and shape the fit you like. Just pick your usual UK / EU dress size below.',
  diagramUrl: null,
  noFinder: true,
  columns: [
    { key: 'uk', label: 'UK', unit: null, measureHint: 'Match to your usual UK dress size.' },
    { key: 'eu', label: 'EU', unit: null, measureHint: 'European dress size equivalent.' }
  ],
  sizes: [
    { size: 'XS',  uk: '4-6',   eu: '32-34' },
    { size: 'S',   uk: '8-10',  eu: '36-38' },
    { size: 'M',   uk: '10-12', eu: '38-40' },
    { size: 'L',   uk: '12-14', eu: '40-42' },
    { size: 'XL',  uk: '14-16', eu: '42-44' },
    { size: 'XXL', uk: '16-18', eu: '44-46' }
  ]
};

// ——————————————————————————————————————————————————————————————————
// UNDERWEAR — FERAL BOXER (boyshorts) + FERAL THONG. Sized S–XL. Stretch
// fabric, so the only fit-relevant number is the waistband (laid flat &
// relaxed; it stretches well beyond this). Table-only (noFinder). UK/EU
// columns are inferred women's dress sizing — CONFIRM before relying on them.
// ——————————————————————————————————————————————————————————————————
window.FERAL_FIT_CHARTS['boxer-standard'] = {
  productType: 'underwear',
  gender: 'female',
  chartTitle: 'FERAL BOXER',
  fitCopy: 'Stretch boyshorts with a wide elastic waistband. The waistband relaxes flat to the measurement below and stretches comfortably to fit.',
  diagramUrl: null,
  noFinder: true,
  hideHowTo: true,
  columns: [
    { key: 'waistband', label: 'Waistband', unit: 'cm', measureHint: 'The waistband laid flat and relaxed, edge to edge — it stretches well beyond this to fit.' },
    { key: 'length',    label: 'Length',    unit: 'cm', measureHint: 'From the waistband straight down to the hem.' }
  ],
  sizes: [
    { size: 'S',  waistband: 32, length: 34 },
    { size: 'M',  waistband: 34, length: 35 },
    { size: 'L',  waistband: 36, length: 36 },
    { size: 'XL', waistband: 38, length: 37 }
  ]
};

window.FERAL_FIT_CHARTS['thong-standard'] = {
  productType: 'underwear',
  gender: 'female',
  chartTitle: 'FERAL THONG',
  fitCopy: 'Stretch thong with a slim elastic waistband. The waistband relaxes flat to the measurement below and stretches comfortably to fit — pick your usual UK / EU size.',
  diagramUrl: null,
  noFinder: true,
  hideHowTo: true,
  columns: [
    { key: 'uk',        label: 'UK',        unit: null, measureHint: 'Match to your usual UK dress size.' },
    { key: 'eu',        label: 'EU',        unit: null, measureHint: 'European dress size equivalent.' },
    { key: 'waistband', label: 'Waistband', unit: 'cm', measureHint: 'The waistband laid flat and relaxed, edge to edge — it stretches well beyond this to fit.' }
  ],
  sizes: [
    { size: 'S',  uk: '8-10',  eu: '36-38', waistband: 33 },
    { size: 'M',  uk: '10-12', eu: '38-40', waistband: 35 },
    { size: 'L',  uk: '12-14', eu: '40-42', waistband: 37 },
    { size: 'XL', uk: '14-16', eu: '42-44', waistband: 39 }
  ]
};

